import React from "react";
import type { GatsbyBrowser } from "gatsby";
import "lenis/dist/lenis.css";
import SmoothScroll from "./src/components/SmoothScroll";
import "./src/styles/global.css";

export const wrapRootElement: GatsbyBrowser["wrapRootElement"] = ({
  element,
}) => React.createElement(SmoothScroll, null, element);

export const shouldUpdateScroll: GatsbyBrowser["shouldUpdateScroll"] = ({
  routerProps,
}) => {
  if (routerProps.location.hash) {
    return true;
  }

  window.setTimeout(() => {
    window.dispatchEvent(new Event("ux-eye-candy:scroll-top"));
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, 0);

  return false;
};
